/**
 * 音频URL处理工具函数
 */

import { AUDIO_BASE_URL } from '@/config/api.js'

/**
 * 构建AI音频完整URL
 * @param {string} audioPath - 相对路径，如 "temp/tts_output_xxx.wav"
 * @returns {string|null} 完整的音频URL
 */
export function buildAIAudioUrl(audioPath) {
  if (!audioPath) {
    return null
  }
  
  // 如果已经是完整URL，直接返回
  if (audioPath.startsWith('http://') || audioPath.startsWith('https://')) {
    return audioPath
  }
  
  // 拼接基础URL
  const path = audioPath.startsWith('/') ? audioPath : `/${audioPath}`
  return `${AUDIO_BASE_URL}${path}`
}

/**
 * 构建用户录音完整URL（如果需要通过服务器播放）
 * @param {string} fileName - 文件名，如 "voice_xxx.amr"
 * @returns {string|null} 完整的音频URL
 */
export function buildUserVoiceUrl(fileName) {
  if (!fileName) {
    return null
  }
  
  // 如果已经是完整URL，直接返回
  if (fileName.startsWith('http://') || fileName.startsWith('https://')) {
    return fileName
  }
  
  // 拼接基础URL（假设用户录音存储在 /user-voices/ 路径下）
  return `${AUDIO_BASE_URL}/user-voices/${fileName}`
}

